import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    dismissAfter: Number,
    showDelay: { type: Number, default: 200 },
    removeDelay: { type: Number, default: 1100 }
  }

  static targets = ["messages"]

  dismissTimeoutHandle = null

  initialize() {
    this.hide()
  }

  connect() {
    if (this.hasMessagesTarget && this.messagesTarget.textContent.trim()) {
      this.init()
    }
  }

  init() {
    setTimeout(() => {
      this.show()
    }, this.showDelayValue)

    // Auto dimiss if defined
    if (this.hasDismissAfterValue) {
      if (this.dismissTimeoutHandle !== null) {
        clearTimeout(this.dismissTimeoutHandle)
      }
      this.dismissTimeoutHandle = setTimeout(() => {
        this.dismissTimeoutHandle = null
        this.close()
      }, this.dismissAfterValue)
    }
  }

  close() {
    this.hide()

    if (this.hasMessagesTarget) {
      setTimeout(() => {
        this.clearMessages()
      }, this.removeDelayValue)
    }
  }

  show() {
    this.element.classList.remove('hidden')
  }

  hide() {
    this.element.classList.add('hidden')
  }

  addMessage(event) {
    if (this.hasMessagesTarget && event.detail.message.length > 0) {
      const paragraph = document.createElement("p")
      paragraph.textContent = event.detail.message
      this.messagesTarget.append(paragraph)
      this.init()
    }
  }

  clearMessages() {
    if (this.hasMessagesTarget) {
      this.messagesTarget.innerHTML = ""
    }
  }

  // treść dopisana przez addMessage() (np. z AJAX-a) nie jest pod data-turbo-temporary
  // (tylko SSR-owy flash w widoku jest) — bez tego reset Turbo cache'owałby żywy, niedomknięty
  // toast i pokazywał go ponownie po przywróceniu strony z cache (wstecz/naprzód)
  reset() {
    if (this.dismissTimeoutHandle !== null) {
      clearTimeout(this.dismissTimeoutHandle)
      this.dismissTimeoutHandle = null
    }
    this.hide()
    this.clearMessages()
  }
}
